import styled from 'styled-components'

export const Content = styled.div`
    margin-left: 250px;
    padding: 1px 16px;

    .new {
        display: flex;
        align-items: center;
        justify-content: center;

        float: right;
        margin-bottom: 15px;
        background: #83bf02;
        padding: 10px;
        border-radius: 5px;
        text-decoration: none;
        border: 0;
        font-weight: 600;
        color: #fff;

        svg {
            margin-right: 5px;
        }

        transition: filter 0.5s;

        &:hover {
            filter: brightness(0.8);
        }
    }

    .container {
        display: flex;
        flex-direction: column;

        background: #f8f8f8;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 10px;

        form {
          display: flex;
          flex-direction: column;
          gap: 10px;

          background: #f8f8f8;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 10px;

          input {
            padding: 8px;
            font-size: 15px;
            border: none;
            border-radius: 5px;
            background: #bdc3c7;
            width: 100%;

            &:disabled {
                cursor: not-allowed;
            }
          }

          button {
            margin: 15px 0;
            background: #181c2e;
            color: #fff;
            border: none;
            border-radius: 5px;
            padding: 8px;
            font-size: 15px;
            width: 100%;
          }
        }
    }

    .boxes-summary {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 5px;

        align-items: center;
        justify-content: start;
        
        width: 100%;

        .box-summary {
            background-color: #7f8c8d;
            width: 250px;
            height: 80px;
            padding: 10px;

            display: flex;
            align-items: start;
            justify-content: start;
            flex-direction: column;

            strong {
                margin-top: 5px;
                display: block;
            }
        }
    }

    @media(max-width:700px){
        margin-left: 0;

        table {
            border: 0;

            thead {
                border: none;
                height: 1px;
                margin: -1px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                width: 1px;
            }

            tr {
                border-bottom: 3px solid #ddd;
                display: block;
                margin-bottom: 10px;
            }

            td {
                border-bottom: 1px solid #ddd;
                display: block;
                font-size: 16px;
                text-align: right;

                
            }

            td::before{
                content: attr(data-label);
                float: left;
                font-weight: bold;
            }
        }
    }
`